

























































import { computed, defineComponent } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";
import { formatMoneyString } from "@/lib/moneyHelpers";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseForm from "@/components/BaseForm";
import BaseInput from "@/components/BaseInput";
import BaseSpinner from "@/components/BaseSpinner";
import FormatMoney from "@/components/FormatMoney";

export default defineComponent({
  name: "CreatePayoutRequestModal",
  components: { BaseConfirm, BaseButton, BaseForm, BaseInput, FormatMoney, BaseSpinner },
  props: {
    show: { type: Boolean, required: true },
    loading: { type: Boolean, default: false },
    externalFeeLoading: { type: Boolean, default: false },
    commission: { type: Number, required: true },
    primaryBalance: { type: Number, required: true },
    value: { type: String, required: true },
    currencySymbol: { type: String, required: true },
    subText: { type: String, required: true },
    hasError: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const onSubmit = async () => {
      emit("submit");
    };
    const hideModal = () => {
      emit("close");
    };

    const amount = computed(() => {
      const numberValue = Number(props.value);
      return isNaN(numberValue) ? 0 : numberValue;
    });

    const profit = computed(() => (amount.value ? amount.value - props.commission : 0));

    const commissionText = computed(() => {
      if (amount.value <= 0) return "";
      return $t("Fee: {0}", [formatMoneyString(amount.value ? props.commission : 0)]);
    });

    const requestButtonText = computed(() => {
      const payoutText = formatMoneyString(profit.value);
      return profit.value > 0 && !props.externalFeeLoading ? $t("Request {0}", [payoutText]) : $t("Request");
    });

    return { onSubmit, hideModal, commissionText, requestButtonText, amount, profit };
  },
});
